export default __webpack_public_path__ + "static/casados-para-sempre-6568b2cd250552cf64cf08c8ad8d02dc.png";